<template>
  <div class="home-page cg-page">
    <div class="login-content">
      <div class="pt20 disflex" style="justify-content: center;position: fixed;background:url(static/images/star.png) no-repeat 0 0;max-width:750px;height: 317px;background-size: cover;    align-items: flex-start;">
        <a class="logo" style="width: 150px;margin: 0 30px;" href="/"><img src="static/images/logo1.png" /></a>
      </div>
      <div class="landing-page">
        <div class="">
          <div class="home-prize" style="padding-top: 185px;">
            <div class="home1 ac">
              <img :src="isEN=='bur'?'../../static/images/login-bg4.png':'../../static/images/login-bg4.png'">
            </div>
          </div>
          <div class="">
            <div class="lg-bg2">
              <div class="ac mt30">
                <div class="drown-list drown-bg" style="">
                  <div class="input-div ">
                    <div class="span fs26 ac fw7" style="font-weight: 400;margin-bottom: 15px;">{{$t('landFont1')}}</div>
                    <div class="input-item">
                      <span>09</span>
                      <input class="input" v-model="mobile" placeholder="">
                    </div>
                  </div>
                  <div class="disflex" style="margin-top: 50px">
                    <div class="drown-li" @click="goLogin()">
                      <div class="disflex day" >
                        <span>{{$t('Login')}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="footer-content ac" style="justify-content: space-evenly;">
              <div class="icon icon2" @click="getHref('faq')">
                <img src="../../static/images/menu-icon5.png" />
                <span>{{$t('FAQs')}}</span>
              </div>
              <div class="icon icon3" @click="getHref('termsAndCondition')">
                <img src="../../static/images/menu-icon6.png" />
                <span>{{$t('TC')}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from '../components/headerNo'
import Dialog from '../components/dialog'
export default {
  components:{
    Header,Dialog
  },
  data() {
    return {
      type:'',
      isEN:'bur',
      mobile:'',
      code:''
    }
  },
  created(){
    if(localStorage.getItem('lang')) this.isEN = localStorage.getItem('lang')
    if (this.$route.query.mobile){
      let that = this
      that.mobile = this.$route.query.mobile;
    }
    if (this.$route.query.type){
      let that = this
      that.type = this.$route.query.type;
    }
    if (this.$route.query.code){
      let that = this
      that.code = this.$route.query.code;
    }
  },
  methods: {
    getHref(type){
      this.$router.push({path:type,query:{type:type}});
    },
    back(){
      this.$router.go(-1);
    },
    goLogin(){
      let that = this
      if(!this.mobile){
        that.$utils.alertText(that.$t('loginTips'),80)
      }else{
        this.checkMobile();
        // this.testLogin()
      }
    },
    checkMobile(){
      let that = this
      that.$parent.loadModal(true);
      let mobile = '09'+this.mobile
      let data = {
        "mobile":mobile
      }
      //检测号码
      that.$api.post('/api/user/check_user',data,r =>{
        that.$parent.loadModal(false);
        if(r.code==1){
          // localStorage.setItem('token',r.data.userinfo.token)
          // localStorage.setItem('mobile',r.data.userinfo.mobile)
          // this.$router.push({path:'/'})
          this.$router.push({path:'/sendOtp',query:{mobile:this.mobile}});
        }else if(r.code==-1){
          if (that.type){
            this.startSub()
          }else{
            this.goLandPage();
          }
        } else{
          that.$utils.alertText(r.msg,100,2000);
        }
      })
    },
    //到land页
    goLandPage(){
      this.$router.push({path:'/land',query:{mobile:'09'+this.mobile,code:this.code,type:this.type}});
    },
    //直接订阅登录
    startSub(){
      let that = this
      that.$parent.loadModal(true);
      let mobile = '09'+this.mobile
      let type  = this.type
      let queryParams = this.$route.query;
      delete queryParams.mobile; // 删除 mobile，避免 URL 里重复
      delete queryParams.type; // 删除 type，避免 URL 里重复
      let queryString = Object.keys(queryParams).length
        ? '&' + Object.entries(queryParams)
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join('&')
        : '';
      let url = '/api/user/sub?mobile='+mobile +'&type='+type+queryString
      that.$api.get(url, {},r =>{
        that.$parent.returnCode(r,function(){
          that.$parent.loadModal(false);
          if (r.code === 1){
            that.$parent.returnCode(r,function(){
              localStorage.setItem('token',r.data.userinfo.token)
              localStorage.setItem('mobile',r.data.userinfo.mobile)
              that.$router.push('/');
            });
          }else{
            that.$utils.alertText(r.msg,80, 2000);
          }
        });
      })
    },
    //测试阶段任意号码直接登录
    testLogin(){
      let that = this
      let mobile = this.mobile
      that.$parent.loadModal(true);
      let url = '/api/user/test_login'
      let data = {
        mobile:mobile
      }
      that.$api.post(url,data,r =>{
        that.$parent.loadModal(false);
        if(r.code === 1){
          localStorage.setItem('token',r.data.userinfo.token)
          localStorage.setItem('mobile',r.data.userinfo.mobile)
          this.$router.push({path:'/'})
          //window.location.href = r.data;
        }else{
          that.$utils.alertText(r.msg,80);
        }
      })
    },
  }
}
</script>
<style scoped>
.drop-down-content{z-index:9;background:none;}
.landing-page{padding-bottom:60px;}
.cg-page{background: url(../../static/images/bg3-png.jpg) no-repeat center top #0034ae;}
.input-item{background:url(../../static/images/input-bg.png) no-repeat center center;background-size: contain;height: 102px;width: 474px;display: flex;align-items: center;}
.input-div div span{color:#0036af;}
.input-div .input{color:#0036af;}
.drown-list{width: auto;margin-top: -40px;}
.drown-bg .drown-li.active::before,.drown-bg .drown-li::before{display: none;}
.drown-list .disflex{font-size: 30px;font-weight: 700;box-shadow: none;background-color: none;text-shadow: #000000 -5px 2px;    margin-top: -12px;}
.week{background: url(../../static/images/week.png) no-repeat;width: 60%;background-size: contain;min-height: 140px;width: 401px;height: 327px;margin: 0 auto;}
.day{background: url(../../static/images/login.png) no-repeat;background-size: contain;min-height: 100px;width: 320px;}
.month{background: url(../../static/images/month.png) no-repeat;background-size: contain;min-height: 100px;width: 275px;}
.lg-bg2{background:url(../../static/images/login-img3.png) no-repeat center 70px;}
</style>



// WEBPACK FOOTER //
// src/page/Login.vue